
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { ChapterData, ThemeData } from '@/types';

@Component({})
export default class ChapterBox extends Vue {
	@Prop() data!: ChapterData;

	private get chapterFinished(): boolean {
		const themes: ThemeData[] = Object.values(this.data.themes);
		for (const theme of themes) {
			if (!this.isThemeFinised(theme.id)) {
				return false;
			}
		}

		return true;
	}

	@Emit()
	private select(): number {
		return this.data.id;
	}

	private isThemeFinised(theme: number): boolean {
		return this.$store.state.finishedThemes.includes(theme);
	}
}
